import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './button.module.scss';
import { getLinkTag, trackEvent } from '../../utils';

const cx = classNames.bind(styles);

function Button(props) {
  const {
    children,
    gtmEventName,
    gtmEventType,
    icon,
    isFull,
    isMobileFull,
    istargetblank,
    label,
    link,
    modifierclass,
    size,
    variant,
  } = props;


  let buttonClassName = cx({
    button: true,
    buttonPrimary: variant === 'primary',
    buttonSecondary: variant === 'secondary',
    buttonPlain: variant === 'plain',
    buttonSmall: size === 'small',
    buttonLarge: size === 'large',
    buttonFull: isFull,
    buttonMobileFull: isMobileFull,
  });

  let Tag = 'button';
  let tagProps = {};

  const linkInformation = getLinkTag(link);
  Tag = linkInformation.tag;
  tagProps = linkInformation.tagProps;

  if (gtmEventName) {
    const eventType = gtmEventType || 'Button';

    if (linkInformation.isExternalLink) {
      tagProps.gtmEventName = eventType;
      tagProps.label = props.gtmEventName;
    } else {
      tagProps.onClick = function () {
        trackEvent(eventType, props.gtmEventName);
      };
    }
  }

  if (istargetblank) {
    tagProps.target = '_blank';
    tagProps.rel = 'noopener noreferrer';
  }

  if (modifierclass) {
    buttonClassName = `${buttonClassName} ${modifierclass}`;
  }

  return (
    <Tag {...tagProps} className={buttonClassName} style={props.style}>
      {icon ? (<i className={`${styles.icon} ${icon}`} data-test="optional-icon" />) : ''}
      <span data-test="button-text">
        {children || label}
      </span>
    </Tag>
  );
}

export default Button;

Button.propTypes = {
  children: PropTypes.string,
  gtmEventName: PropTypes.string,
  gtmEventType: PropTypes.string,
  icon: PropTypes.string,
  isFull: PropTypes.bool,
  isMobileFull: PropTypes.bool,
  istargetblank: PropTypes.bool,
  label: PropTypes.string,
  link: PropTypes.string.isRequired,
  modifierclass: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
};

Button.defaultProps = {
  children: '',
  gtmEventName: '',
  gtmEventType: '',
  icon: '',
  isFull: false,
  isMobileFull: false,
  istargetblank: false,
  label: '',
  modifierclass: '',
  size: 'regular',
  variant: 'primary',
};
